import { BackgroundNS } from "../../../../../../Background/BackgroundNS.js";
export const setBackground = (self, background_value_vo) => {
  const background = self._getBackgroundThrowable();
  if (background_value_vo.type === "color") {
    background.setValue(
      new BackgroundNS.ModelNS.BackgroundColorValue({
        fill: background_value_vo.fill,
        opacity: background_value_vo.opacity,
      })
    );
    return;
  }
  if (background_value_vo.type === "image") {
    background.setValue(
      new BackgroundNS.ModelNS.BackgroundImageValue({
        url: background_value_vo.url,
        data_url: background_value_vo.data_url,
        opacity: background_value_vo.opacity,
      })
    );
  }
};
